import { wsSend } from './websocketActions';

export const getLicensingInfo = () => (dispatch) => dispatch(wsSend({
  type: 'GET_LICENSING_INFO_REQ',
  payload: {},
}));

export default {};
